var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('router-view'),(_vm.notErrorPage)?_c('FooterMenu'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }